import { css } from 'styled-components'; // SHARED FUNCTIONS...

var gutterFunction = function gutterFunction(gutterValue, gutterSize) {
  var gutterToReturn = 0;

  if (gutterValue === -1) {
    gutterToReturn = "-".concat(gutterSize);
  } else if (gutterValue === 0) {
    gutterToReturn = 0;
  } else {
    gutterToReturn = gutterSize;
  }

  return gutterToReturn;
};

var hasGutterValue = function hasGutterValue(gutterValue) {
  return [-1, 0, 1].includes(gutterValue);
}; //  ROW FUNCTIONS...


var breakpointOrder = ['xs', 'sm', 'md', 'lg'];

var paddingGutterFunction = function paddingGutterFunction(gutterValue, gutterSize) {
  return gutterValue === -1 ? 0 : gutterFunction(gutterValue, gutterSize);
};

var rowVariants = function rowVariants(gutterSize, gutterValue) {
  return {
    hiddenBreakpoint: 'display: none;',
    block: 'display: block;',
    row: 'display: flex; flex-direction: row; flex-wrap: wrap;',
    stack: 'display: flex; flex-direction: column; flex-wrap: nowrap;',
    wrap: 'flex-wrap: wrap;',
    noWrap: 'flex-wrap: nowrap;',
    rowReverse: 'flex-direction: row-reverse;',
    columnReverse: 'flex-direction: column-reverse;',
    negative: "width: auto; margin-left: -".concat(gutterSize, "; margin-right: -").concat(gutterSize, "} padding-right: ").concat(gutterValue === 1 && gutterSize, ";")
  };
};

var gutterPaddings = function gutterPaddings(props) {
  return {
    xs: paddingGutterFunction(props.xsGutterValue, props.gutterSize),
    sm: paddingGutterFunction(props.smGutterValue, props.gutterSize),
    md: paddingGutterFunction(props.mdGutterValue, props.gutterSize),
    lg: paddingGutterFunction(props.lgGutterValue, props.gutterSize)
  };
};

var createVariant = function createVariant(row, gutterSize, gutterValue) {
  var rows = row.reduce(function (rowStyle, item) {
    return rowStyle.concat(rowVariants(gutterSize, gutterValue)[item]);
  }, '');
  return css(["", ""], rows);
};

var filterProps = function filterProps(requiredProps, props) {
  return Object.entries(props).filter(function (item) {
    return requiredProps.includes(item[0]) && (item[1] || hasGutterValue(item[1]));
  });
};

var reduceBreakpoints = function reduceBreakpoints(refinedProps) {
  return refinedProps.reduce(function (accumulator, item) {
    if (Object.keys(accumulator).includes(item[1])) {
      accumulator[item[1]].push(item[0]);
    } else {
      accumulator[item[1]] = [item[0]];
    }

    return accumulator;
  }, {});
};

var orderBreakpoints = function orderBreakpoints(rowBreakpoints) {
  return Object.entries(rowBreakpoints).sort(function (a, b) {
    return breakpointOrder.indexOf(a[0]) - breakpointOrder.indexOf(b[0]);
  });
};

var orderGutterValues = function orderGutterValues(props) {
  var gutterValueProps = ['gutterValue', 'xsGutterValue', 'smGutterValue', 'mdGutterValue', 'lgGutterValue'];
  var lastGutterValue = props.gutterValue;
  return gutterValueProps.map(function (key) {
    if (hasGutterValue(props[key])) {
      lastGutterValue = props[key];
      return props[key];
    }

    return lastGutterValue;
  });
};

var getLatestGutterValue = function getLatestGutterValue(gutterValues, breakpoint) {
  return gutterValues[breakpointOrder.indexOf(breakpoint) + 1];
};

var hasNegativeMargins = function hasNegativeMargins(negative, breakpoint) {
  return negative ? breakpointOrder.indexOf(negative) < breakpointOrder.indexOf(breakpoint) : false;
};

var generateMediaQueries = function generateMediaQueries(props) {
  var orderedGutterValues = orderGutterValues(props);
  var requiredProps = ['hiddenBreakpoint', 'block', 'row', 'stack', 'wrap', 'noWrap', 'rowReverse', 'columnReverse', 'negative'];
  var refinedProps = filterProps(requiredProps, props);
  var rowBreakpoints = reduceBreakpoints(refinedProps);
  var orderedBreakpoints = orderBreakpoints(rowBreakpoints);
  return orderedBreakpoints.map(function (row) {
    var latestGutterValue = getLatestGutterValue(orderedGutterValues, row[0]);
    return css(["@media screen and (min-width:", "){", "}"], props.theme.size.breakpoint['min-width'][row[0]], createVariant(row[1], props.gutterSize, latestGutterValue));
  });
};

var generateMediaQueriesForGutterValue = function generateMediaQueriesForGutterValue(props) {
  var gutterBreakpoints = ['xsGutterValue', 'smGutterValue', 'mdGutterValue', 'lgGutterValue'];
  var refinedProps = filterProps(gutterBreakpoints, props);
  return refinedProps.map(function (row) {
    var breakpoint = row[0].substring(0, 2);
    var negativeMargins = hasNegativeMargins(props.negative, breakpoint);
    return css(["@media screen and (min-width:", "){", "}"], props.theme.size.breakpoint['min-width'][breakpoint], props[row[0]] === 1 ? css(["margin-left:", ";padding-right:", ";"], !negativeMargins && "calc(-".concat(props.gutterSize, " / 2)"), negativeMargins ? props.gutterSize : "calc(".concat(props.gutterSize, " / 2)")) : css(["margin-left:", ";padding-right:", ";"], !negativeMargins && 0, gutterPaddings(props)[breakpoint]));
  });
}; //  COLUMN FUNCTIONS...


var calculateGutterWidth = function calculateGutterWidth(gutterSize, gutterValue) {
  return gutterValue === -1 ? "+ ".concat(gutterSize, "*2") : "- ".concat(gutterSize);
};

var setWidth = function setWidth(widthPercentage, gutterSize, gutterValue) {
  var flexCSS = 'flex: 0 0 auto;';
  var gutterWidthCSS = "calc(".concat(widthPercentage, "% ").concat(calculateGutterWidth(gutterSize, gutterValue), ")");

  if (gutterValue === 0) {
    return css(["", " flex-basis:", "%;max-width:", "%;"], flexCSS, widthPercentage, widthPercentage);
  }

  return css(["", " flex-basis:", ";max-width:", ";"], flexCSS, gutterWidthCSS, gutterWidthCSS);
};

var widthCalculator = function widthCalculator(numberOfColumns, size, gutterValue, gutterSize) {
  var widthPercentage = size / numberOfColumns * 100;
  return setWidth(widthPercentage, gutterSize, gutterValue);
};

var offsetCalculator = function offsetCalculator(props, offset, gutterSize) {
  var widthPercentage = offset / props.numberOfColumns * 100;
  return css(["margin-left:calc(", "% + (", "));"], widthPercentage, gutterSize);
};

export { hasGutterValue, filterProps, reduceBreakpoints, orderBreakpoints, generateMediaQueries, generateMediaQueriesForGutterValue, setWidth, widthCalculator, gutterFunction, offsetCalculator, orderGutterValues, getLatestGutterValue, hasNegativeMargins };